// Visionneuse de photos (retours, avis) : un clic sur <a data-pd-photo href="…"> ouvre l'image en plein
// écran au lieu de charger le fichier brut dans l'onglet. Les liens qui partagent data-pd-photo-group
// se parcourent avec ← → ; Échap ou un clic à côté referme. Sans dépendance, fonctionne dans un
// rendu Blazor (délégation sur le document) comme dans une page d'administration MVC.
(function () {
    if (window.PdPhotoLightbox) return;
    var overlay = null, img = null, caption = null, group = [], index = 0;

    function ensure() {
        if (overlay) return;
        overlay = document.createElement('div');
        overlay.id = 'pd-photo-lightbox';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.style.cssText = 'position:fixed;inset:0;z-index:100000;background:rgba(10,10,10,.92);display:none;align-items:center;justify-content:center;flex-direction:column;gap:12px;padding:24px;box-sizing:border-box;';
        overlay.innerHTML =
            '<button type="button" data-pd-lb="close" aria-label="Fermer" style="position:absolute;top:14px;right:16px;width:40px;height:40px;border-radius:50%;border:1px solid rgba(255,255,255,.35);background:rgba(0,0,0,.35);color:#fff;font-size:22px;line-height:1;cursor:pointer">×</button>' +
            '<button type="button" data-pd-lb="prev" aria-label="Photo précédente" style="position:absolute;left:14px;top:50%;transform:translateY(-50%);width:44px;height:44px;border-radius:50%;border:1px solid rgba(255,255,255,.35);background:rgba(0,0,0,.35);color:#fff;font-size:26px;line-height:1;cursor:pointer">‹</button>' +
            '<button type="button" data-pd-lb="next" aria-label="Photo suivante" style="position:absolute;right:14px;top:50%;transform:translateY(-50%);width:44px;height:44px;border-radius:50%;border:1px solid rgba(255,255,255,.35);background:rgba(0,0,0,.35);color:#fff;font-size:26px;line-height:1;cursor:pointer">›</button>' +
            '<img alt="" style="max-width:min(96vw,1400px);max-height:84vh;object-fit:contain;border-radius:8px;box-shadow:0 20px 60px rgba(0,0,0,.6);background:#111" />' +
            '<div data-pd-lb="caption" style="color:#e5e7eb;font:500 13px/1.4 system-ui,sans-serif;letter-spacing:.02em"></div>';
        document.body.appendChild(overlay);
        img = overlay.querySelector('img');
        caption = overlay.querySelector('[data-pd-lb="caption"]');
        overlay.addEventListener('click', function (e) {
            var b = e.target.closest && e.target.closest('[data-pd-lb]');
            if (b) { var k = b.getAttribute('data-pd-lb'); if (k === 'close') close(); else if (k === 'prev') step(-1); else if (k === 'next') step(1); return; }
            if (e.target === overlay) close();
        });
        document.addEventListener('keydown', function (e) {
            if (!overlay || overlay.style.display === 'none') return;
            if (e.key === 'Escape') close();
            else if (e.key === 'ArrowLeft') step(-1);
            else if (e.key === 'ArrowRight') step(1);
        });
    }

    function show() {
        var a = group[index];
        img.src = a.getAttribute('href');
        img.alt = a.getAttribute('data-pd-photo-alt') || '';
        caption.textContent = group.length > 1 ? (index + 1) + ' / ' + group.length : '';
        overlay.querySelector('[data-pd-lb="prev"]').style.display = group.length > 1 ? '' : 'none';
        overlay.querySelector('[data-pd-lb="next"]').style.display = group.length > 1 ? '' : 'none';
        overlay.style.display = 'flex';
        document.documentElement.style.overflow = 'hidden';
    }
    function step(d) { if (!group.length) return; index = (index + d + group.length) % group.length; show(); }
    function close() { if (!overlay) return; overlay.style.display = 'none'; img.src = ''; document.documentElement.style.overflow = ''; }
    function open(a) {
        ensure();
        var g = a.getAttribute('data-pd-photo-group');
        group = g ? Array.prototype.slice.call(document.querySelectorAll('a[data-pd-photo][data-pd-photo-group="' + CSS.escape(g) + '"]')) : [a];
        index = Math.max(0, group.indexOf(a));
        show();
    }

    document.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
        var a = e.target.closest && e.target.closest('a[data-pd-photo]');
        if (!a || !a.getAttribute('href')) return;
        e.preventDefault();
        open(a);
    }, true);

    window.PdPhotoLightbox = { open: open, close: close };
})();
